// Import the updated axiosConfig and reactQueryConfig
import { QueryClient } from "@tanstack/react-query";

import { axiosInstance, reactQueryConfig } from "@configs";
// Import statements...

const axiosClient = axiosInstance;

const queryClient = new QueryClient(reactQueryConfig);

export { axiosClient, queryClient };
